<template>
    <div>
        <h6 v-if="item.title" class="mb-2">{{ item.title }}</h6>
        <p v-if="item.content" class="text-wrap-pre-line text-muted">{{ item.content }}</p>
        <ul v-if="item.list && item.list.length" class="text-muted">
            <li v-for="(listItem, index) in item.list" :key="`things-to-know-list-item-${index}`">{{ listItem }}</li>
        </ul>
    </div>
</template>

<script type="text/javascript">

    export default {

        props: {
            item: {
                type: Object,
                required: true,
            },
        },
    };

</script>
